<template>
  <div>
    <b-card no-body>
      <b-card-header
        class="d-flex align-items-center"
        header-tag="header"
        role="tab"
        header-bg-variant="dark"
      >
        <div>
          <b>{{ checklistItem.checklistItemDetails.name }}</b>
          <div class="text-muted">
            {{ checklistItem.checklistItemDetails.description }}
          </div>
        </div>

        <b-badge
          class="fixed-width-130 py-1 ml-auto"
          tag="div"
          :variant="getBadge(checklistItem.status)"
        >
          <div class="checklist-item__status">
            {{ checklistItemStatus }}
          </div>
        </b-badge>
      </b-card-header>
    </b-card>
  </div>
</template>

<script>
const statusMapping = {
  'NotRequested': 'In Progress',
  'Requested': 'Requested',
  'Received': 'Received',
  'Verified': 'Verified',
  'Failed': 'Failed',
  'Canceled': 'Canceled',
}
export default {
  name: 'VerificationChecklistItem',

  props: {
    checklistItem: {
      type: Object,
      required: true
    },
  },

  computed: {
    checklistItemStatus() {
      const status = this.checklistItem?.status ?? 'NotRequested'

      return statusMapping[status] 
    },
  },

  methods: {
    getBadge(status) {
      switch (status) {
      case 'Not Requested':
      case 'NotRequested':
      case 'Received':
        return 'warning'

      case 'Verified':
        return 'success'

      case 'Failed':
        return 'danger'

      default:
        return 'secondary'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.checklist-item__status {
  font-size: 0.8rem;
}
</style>